module.exports = __webpack_public_path__ + "img/full-star.f75fcb04.svg";